import React from "react";
import Breadcrumb from "../../../common//Breadcrumb";
import BlogSiebarWrap from "./BlogSiebarWrap";

function BlogSidebar() {
  return (
    <>
      <Breadcrumb name="Blog Sidebar" />
      <BlogSiebarWrap />
    </>
  );
}

export default BlogSidebar;
